import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
const Marqueelow = () => {
  const marqueeInnerRef = useRef();

useEffect(() => {
  const marqueeInner = marqueeInnerRef.current;

  const startAnimation = () => {
    requestAnimationFrame(() => {
      const totalWidth = marqueeInner.offsetWidth / 2;

      gsap.fromTo(
        marqueeInner,
        { x: 0 },
        {
          x: -totalWidth,
          duration: 20,
          ease: 'linear',
          repeat: -1,
        }
      );
    });
  };

  const images = marqueeInner.querySelectorAll('img');
  let loaded = 0;

  images.forEach((img) => {
    if (img.complete) {
      loaded++;
    } else {
      img.onload = () => {
        loaded++;
        if (loaded === images.length) startAnimation();
      };
    }
  });

  if (loaded === images.length) startAnimation();
}, []);


  return (
    <div className="marquee1" >
                                     <div className="marquee__inner" ref={marqueeInnerRef}>
                                <div className="marquee__group">
                                    <div>
                                        <img className='imgunder' src="\assets\opt.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\base.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\sui.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\xrp.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\card.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\tron.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\apt.svg" />
                                    </div>
                                          <div>
                                        <img className='imgunder' src="\assets\opt.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\base.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\sui.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\xrp.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\card.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\tron.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\apt.svg" />
                                    </div>
                                </div>
                                <div className="marquee__group">
                                    <div>
                                        <img className='imgunder' src="\assets\opt.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\base.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\sui.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\xrp.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\card.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\tron.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\apt.svg" />
                                    </div>
                                          <div>
                                        <img className='imgunder' src="\assets\opt.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\base.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\sui.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\xrp.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\card.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\tron.svg" />
                                    </div>
                                    <div>
                                        <img className='imgunder' src="\assets\apt.svg" />
                                    </div>
                                </div>
                                </div>
                            </div>
  )
}

export default Marqueelow